import { FC, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faCheck } from "@fortawesome/free-solid-svg-icons";
import styles from "./styles.module.scss";

/**
 * Wartość w komórce rejestru z ikoną „Kopiuj" pojawiającą się na hover.
 * `display` — tekst pokazywany (np. z maską), `copyValue` — co trafia do schowka
 * (domyślnie to samo co `display`). Pusty `display` → nic nie renderuje.
 */
const CopyableValue: FC<{
  display?: string;
  copyValue?: string;
  label?: string;
}> = ({ display, copyValue, label = "Kopiuj" }) => {
  const [copied, setCopied] = useState(false);
  const shown = (display ?? "").trim();

  if (!shown) return null;

  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigator.clipboard.writeText(copyValue ?? shown).catch(() => {});
    setCopied(true);
    setTimeout(() => setCopied(false), 1200);
  };

  return (
    <div className={styles.row}>
      <span className={styles.value} title={shown}>
        {shown}
      </span>
      <span
        className={styles.copy}
        onClick={handleCopy}
        title={copied ? "Skopiowano" : label}
      >
        <FontAwesomeIcon icon={copied ? faCheck : faCopy} />
      </span>
    </div>
  );
};

export default CopyableValue;
